var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center text--primary"},[_vm._v(" CREATE A FRAME TO UPLOAD MANY FILES AND SAVE IT IN A PATH IN THE BACKEND. THE PATH WHERE ALL THE IMAGE ARE SAVED SHOULD BE upload/\"The username\"/ ")])
}
var staticRenderFns = []

export { render, staticRenderFns }